module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/styles/fonts/glyphicons/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/styles/fonts/glyphicons/glyphicons-halflings-regular.svg
// module chunks = styles